import { render, staticRenderFns } from "./ApprovalStepper.vue?vue&type=template&id=32b2a27c&scoped=true"
import script from "./ApprovalStepper.vue?vue&type=script&lang=js"
export * from "./ApprovalStepper.vue?vue&type=script&lang=js"
import style0 from "./ApprovalStepper.vue?vue&type=style&index=0&id=32b2a27c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b2a27c",
  null
  
)

export default component.exports